<template>
  <!-- Item của combo không có column -->
  <li
    v-if="comboType === 1"
    class="combobox-item single"
    :class="{'parent':item.isParent}"
    :style="'text-align: '+align"
    v-on="listeners"
  >
    <div class="combobox-item-con">
      <!-- Dữ liệu dạng text -->
      <div
        v-if="!insertHTML"
        class="combobox-item--text"
        :title="getItemDisplay(item)"
      >
        <slot name="item">
          {{ getItemDisplay(item) }}
        </slot>
      </div>

      <!-- Dữ liệu dạng HTML -->
      <div
        v-else
        v-html="getItemDisplay(item)"
      />
      <span
        v-if="hasRemoveItemButton"
        class="trash-icon"
        @click="onRemoveItemClick()"
      >
        <span class="mi mi-16 mi-garbage" />
      </span>
    </div>
  </li>
  <li
    v-else-if="comboType === 3 && columnx.length == 0"
    class="combobox-item single"
    :class="{'parent':item.isParent}"
    :style="'text-align: '+align"
    v-on="listeners"
  >
    <div class="combobox-item-con">
      <div
        class="combobox-item--text"
        :class="`level-${item.level}`"
        :title="getItemDisplay(item)"
      >
        {{ getItemDisplay(item) }}
      </div>
      <span
        v-if="hasRemoveItemButton"
        class="trash-icon"
        @click="onRemoveItemClick()"
      >
        <span class="mi mi-16 mi-garbage" />
      </span>
    </div>
  </li>
  <!-- Item của combo có column -->
  <tr
    v-else
    class="combobox-item"
    :class="{'parent':item.isParent}"
    v-on="listeners"
  >
    <td
      v-for="(column, tdIndex) in columnx"
      :key="tdIndex"
      class="combobox-item-td"
      :class="(comboType === 3 && tdIndex === 0) ? `level-${item.level}` : null"
      :style="getTdStyle(column)"
    >
      <div class="combobox-item-td--contents">
        <div
          :title="getItemDisplay(item, column)"
          class="combobox-item-td--text"
        >
          {{ getItemDisplay(item, column) }}
        </div>
      </div>
    </td>
    <td class="selected-container">
      <div
        v-if="item.multiSelected"
        class="selected"
      />
    </td>
  </tr>
</template>

<script>
export default {
	name: 'MsComboBoxItem',
	props: {
		/**
		 * Loại combo
		 */
		comboType: {
			type: Number,
			default: 1
		},

		/**
		 * Item sử dụng để binding
		 */
		item: {},

		/**
		 * Cấu hình cột của menu
		 */
		columnx: {
			type: Array,
			default: []
		},
		/**
		 * Trường làm value
		 * CreatedBy PDKIEN 10/12/2019
		 */
		valueField: {
			type: String,
			default: null
		},
		/**
		 * Trường là display
		 * CreatedBy PDKIEN 10/12/2019
		 */
		displayField: {
			type: String,
			default: null
		},

		/**
		 * Trạng thái có btn `Xóa` trong item
		 */
		hasRemoveItemButton: {
			type: Boolean,
			default: false
		},
		/**
		 * Kiểu định dạng dữ liệu trên combobox
		 * Tương ứng với FormatType
		 * CreatedBy PDKIEN 07/12/2019
		 */
		formatType: {
			type: [Number, String],
			default: null
		},
		align: {
			type: String,
			default: 'left'
		},
		// Dữ liệu chèn vào combox item có là HTML
		insertHTML: {
			default: false,
			type: [String, Boolean]
		}
	},
	computed: {
		/**
		 * Binding sự kiện của menu item
		 */
		listeners() {
			let me = this;
			return {
				...me.$listeners
			};
		}
	},
	methods: {
		/**
		 * Hàm lấy style cho td trong table
		 * dữ liệu động theo config của dev
		 */
		getTdStyle(column) {
			return {
				width: column.isResize ? null : `${column.width}px`,
				textAlign: column.columnAlign
			};
		},

		/**
		 * Lấy text hiển thị trên item
		 * Nếu có column lấy theo column.field, nếu không có column lấy theo displayField, nếu không có displayField lấy theo valueField
		 * CreatedBy PDKIEN 10/12/2019
		 */
		getItemDisplay(item, column) {
			let field = column
				? column.dataField
				: this.displayField || this.valueField;
			if (field) {
				return item[field];
			} else {
				return item;
			}
		},

		/**
		 * Xử lý sự kiện khi click icon xóa item
		 */
		onRemoveItemClick() {
			this.$emit('removeItem');
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/controls/var-color.scss"; 
@import "@/assets/scss/controls/_variables.scss"; 
.combobox-item {
	display: flex;
	align-items: center;
	cursor: pointer;
	// height: var(--combo-box-height);
	height: auto;
	line-height: var(--combo-box-height);
	white-space: nowrap;
	&:hover {
		background: var(--primary-bg);
		color: var(--combobox-color);
	}
	&.parent {
		font-weight: bold;
	}
	&.single {
		display: block;
	}
	.combobox-item--text,
	.combobox-item--text span {
		flex: 1;
		padding: 0 10px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: $font-size-body;
	}
	.trash-icon {
		width: 24px;
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		margin: 0 10px;
	}
	.combobox-item-td {
		padding: 0 10px;
		.combobox-item-td--contents {
			display: flex;
			align-items: center;
		}
		.combobox-item-td--text {
			flex: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
}
.selected-container {
	width: 36px;
	height: 20px;
	.selected {
		padding-right: 10px;
		// background: url('~@/assets/images/Sprites.svg') no-repeat;
		background-position: -896px -312px;
		width: 16px;
		height: 16px;
	}
}
@for $i from 1 through 10 {
	$x: ($i - 1) * 10 + 10;
	.level-#{$i} {
		padding-left: #{$x}px !important;
	}
}
</style>
